import { useMaterialsStore } from "@/store/modules/material";
import { useAnalysisStore } from "@/store/modules/analysis";
import { useParametersStore } from "@/store/modules/parameters";
import { useRolesStore } from "@/store/modules/roles";
import { useAgenciesStore } from "@/store/modules/agencies";
import { useConstatsStore } from "@/store/modules/constats";
import { useProjectsStore } from "@/store/modules/projects";

import { multiGuard } from "@/utils/router";

import AtmoChildrens from "@/router/atmo/children";
import { VITE_APP_ATMO_SERVICE_ID } from "@/env";

const OidcCallback = () =>
  import(
    /* webpackChunkName: "OidcCallback" */ "@/components/OidcCallback.vue"
  );
import { isLoggedOrOffline, isOffline } from "@/offline/guards";
import { OfflineError } from "@/utils/errors";
import { isNetworkError } from "@/utils/network";

const Atmo = () =>
  import(/* webpackChunkName: "Atmo" */ "@/components/Atmo.vue");
const UnauthorizedAccessOfflineMode = () =>
  import(
    /* webpackChunkName: "UnauthorizedAccessOfflineMode" */ "@/offline/UnauthorizedAccessOfflineMode.vue"
  );

const fetchMaterials = async (to, from, next) => {
  useMaterialsStore().fetchMaterials();
  next();
};
const fetchAnalysis = async (to, from, next) => {
  useAnalysisStore().fetchAnalysis();
  next();
};

const fetchParameters = async (to, from, next) => {
  useParametersStore().fetchParameters();
  next();
};

const fetchRoles = async (to, from, next) => {
  useRolesStore().fetchRoles({
    filters: {
      service_id: VITE_APP_ATMO_SERVICE_ID,
    },
  });
  next();
};

const fetchAgencies = async (to, from, next) => {
  useAgenciesStore().fetchAgencies();
  next();
};

const fetchConstats = async (to, from, next) => {
  useConstatsStore().syncCatalog();
  next();
};

const fetchFavorites = async (to, from, next) => {
  useProjectsStore()
    .fetchFavorites()
    .catch((error) => {
      if (error instanceof OfflineError || isNetworkError(error)) return;
      throw error;
    });
  next();
};

export default [
  {
    path: "/",
    component: Atmo,
    children: AtmoChildrens,
    beforeEnter: multiGuard([
      isLoggedOrOffline,
      fetchMaterials,
      fetchAnalysis,
      fetchRoles,
      fetchParameters,
      fetchAgencies,
      fetchConstats,
      fetchFavorites,
    ]),
  },
  {
    path: "/oidc-callback", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallback",
    component: OidcCallback,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/unauthorized-access-offline-mode",
    name: "unauthorized-access-offline-mode",
    component: UnauthorizedAccessOfflineMode,
    beforeEnter: isOffline,
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: { name: "not-found" },
  },
];
